import React from 'react';
import cx from 'classnames';
import './loader.css';

export enum LoaderSize {
  small = 'small',
  medium = 'medium',
  large = 'large',
}
export interface LoaderProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const sizeToClass: Record<LoaderSize, string> = {
  [LoaderSize.small]: 'phill-loader-sm',
  [LoaderSize.medium]: 'phill-loader-md',
  [LoaderSize.large]: 'phill-loader-lg',
};

const BaseLoader: React.FC<LoaderProps> = ({ className, ...props }: LoaderProps) => (
  <div className={cx('phill-base-loader', className)} {...props} />
);

export const ContentLoader: React.FC = () => <BaseLoader className="phill-content-loader" />;

export const Loader = ({
  absolute = true,
  className,
  size = LoaderSize.medium,
}: {
  absolute?: boolean;
  className?: string;
  size?: LoaderSize;
}): JSX.Element => {
  const sizeClass = sizeToClass[size];
  if (!absolute) {
    return <BaseLoader className={cx('phill-loader', 'phill-loader-static', sizeClass, className)} />;
  }
  return (
    <div className="phill-loader-wrapper">
      <BaseLoader className={cx('phill-loader', sizeClass, className)} />
    </div>
  );
};
